import React, { useState } from 'react'
import { motion } from 'framer-motion'
import TocRoundedIcon from '@mui/icons-material/TocRounded';
import Items from '../../componants/Item/Items';
import DesktopWindowsRoundedIcon from '@material-ui/icons/DesktopWindowsRounded';
import CategoryRoundedIcon from '@material-ui/icons/CategoryRounded';
import ComputerRoundedIcon from '@material-ui/icons/ComputerRounded';
import EmojiPeopleRoundedIcon from '@material-ui/icons/EmojiPeopleRounded';
import WbIncandescentRoundedIcon from '@material-ui/icons/WbIncandescentRounded';
import TabRoundedIcon from '@material-ui/icons/TabRounded';
import TabletAndroidRoundedIcon from '@material-ui/icons/TabletAndroidRounded';
import Globalcontext from '../../Context/Globalcontext';
import { SidebarData1 } from "../../Data/Data";
import { SidebarData2 } from "../../Data/Data";
import { SidebarData3 } from "../../Data/Data";
import Logo from "../../imgs/logo.png";
import './Sidebar.css'
import Body from '../Body/Body';
import Dashboard from '../Dashboard/Dashboard'
import { useLocation, useNavigate } from "react-router-dom";
import Test from '../Test/Test';
import { useContext } from 'react';

const Sidebar = () => {
  const a = useContext(Globalcontext);
  const [open, setOpen] = useState(true);

  const handleToggle = () => {
    setOpen(!open);
  }

  const tohome = () => {
    navigate("/Dashboard");
  }

  const location = useLocation();
  const sideContainerVariants = {
    true: {
      width: '14rem',
    },
    false: {
      transition: {
        delay: 0.4
      }
    }
  }

  const sidebarvariants = {
    true: {},
    false: {
      width: '3rem',
      transition: {
        delay: 0.4
      }
    }
  }

  const profilevariants = {
    true: {
      alignSelf: 'center',
      width: '8rem'
    },
    false: {
      alignSelf: 'flex-start',
      left: '0',
      marginTOp: '2rem',
      width: '3.5rem',
      transition: {
        delay: 0.4
      }
    }
  }

  const navigate = useNavigate();
  return (
    <div className='main2'>
      <motion.div
        data-open={open}
        variants={sideContainerVariants}
        initial={`${open}`}
        animate={`${open}`}
        className="sidebar_container">

        <motion.div
          initial={`${open}`}
          animate={`${open}`}
          variants={sidebarvariants}
          className="sidebar">
          <motion.div
            whileHover={
              {
                scale: 1.2,
                rotate: 180,
                backgroundColor: "rgba(255,255,255,0.3)",
                backdrpFilter: "blur(3.5px)",
                WebkitBackdropFilter: "blur(3.5px)",
                border: "1px solid rgba(255,255,255,0.18)",
                cursor: "pointer",
                transition: {
                  delay: 0.2,
                  duration: 0.4
                }

              }
            }
            onClick={handleToggle}
            className="lines_icon">
            <TocRoundedIcon />
          </motion.div>
          <motion.div
            initial={`${open}`}
            animate={`${open}`}
            variants={profilevariants}
            transition={{ duration: 0.4 }}
            whileHover={{

              backdrpFilter: "blur(5.5px)",
              borderRadius: "10px",
              border: "1px solid rgba( 255, 255, 255, 0.18 )"
            }}
            onClick={tohome}
            className="profile">
            <img src={Logo} alt="" />
          </motion.div>
          <div className="groups">
            <div className="group">
              <motion.h3
                animate={{ opacity: open ? 1 : 0, height: open ? 'auto' : 0 }}
              >Test Section</motion.h3>
              {SidebarData1.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {
                      a.setTestname(item.heading2);
                      navigate("/test");
                    }}
                  >
                    <Items icon={<item.icon />} name={item.heading2} />
                    {/* <Link className="linktext" to={""}>
                      {item.heading2}{" "}
                    </Link> */}
                  </div>
                );
              })}
            </div>
            <div className="group">
              <motion.h3
                animate={{ opacity: open ? 1 : 0, height: open ? 'auto' : 0 }}
              >Services</motion.h3>
              {SidebarData2.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {

                    }}
                  >
                    <Items icon={<item.icon />} name={item.heading2} />

                  </div>
                );
              })}
            </div>

            <div className="group">
              <motion.h3
                animate={{ opacity: open ? 1 : 0, height: open ? 'auto' : 0 }}
              >Other</motion.h3>
              {SidebarData3.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {

                    }}
                  >
                    <Items icon={<item.icon />} name={item.heading2} />

                  </div>
                );
              })}
            </div>
          </div>
        </motion.div>
      </motion.div>
      <div className="rightt">
        {location.pathname === '/Dashboard' ? <Dashboard open={open} /> : <Test testname={a.testname} open={open} />}
      </div>

    </div>
  )
}
export default Sidebar

